module.exports = __webpack_public_path__ + "media/brand/MP-738f8dcc.png";